<template>
  <div id="app2" class="home">
    <el-row>
      <el-col :span="5" style="position: relative;" v-show="flag">
        <span class="el-icon-d-arrow-left" v-show="flag" @click="
            flag = !flag;
            num = 24;
          "></span>
        <span style="padding: 10px;display: block;">
          <el-input size="medium" placeholder="输入关键字进行过滤" v-model="filterText">
          </el-input>
        </span>
        <el-tree class="filter-tree" :data="treeList" :props="defaultProps" :filter-node-method="filterNode" :expand-on-click-node='false'
          node-key="Id" ref="tree" accordion auto-expand-parent>
          <template #default="{ node, data }" >
            <span class="custom-tree-node" :class="{'name-wrapper':tempId==data.Id}" @click="virtaul(data)">
              <span>
                <el-popover trigger="hover" placement="top" :open-delay='500'>
                  <!-- <p>{{ data.Name }}</p> -->
                  <p>{{ data.Content.Name }}</p>
                  <div slot="reference" >
                    <!-- {{ data.Name }} -->
                    {{ data.Content.Name }}
                  </div>
                </el-popover>
              </span>
            </span>
          </template>
        </el-tree>
      </el-col>
      <el-col :span="num"
        style="position: relative;border-left: 10px solid #eceef2; height: calc(100vh - 110px);padding: 5px;">
        <span class="el-icon-d-arrow-right" v-show="!flag" @click="
            flag = !flag;
            num = 19;"></span>
        <span style="margin:9px;display:block;">
          <el-button type="primary" icon="el-icon-document-add" @click="add_ed">添加变量</el-button>
          <el-button type="danger" @click="delete_fn">批量删除</el-button>
        </span>
        <el-table
          :header-cell-style="{color:'#333',fontFamily:'MicrosoftYaHeiUI',fontSize:'14px',fontWeight:900,backgroundColor:'#f5f7fa'}"
          stripe :data="tableData" border style="width: 100%" :max-height="heights+130"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="40">
     
          </el-table-column>
          <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
          <el-table-column v-for="(item,index) in columns" :key="index" :label="item.name" align="center"
            :width="item.width || 'auto'">
            <!-- AreaUpId -->
            <template slot-scope="{row}"> 
              <span >{{row[item.key]}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="110">
            <template #default="{row}">
              <span>
              <el-button type="danger" v-if="row.Id" @click="deleteData = [row.Id];delete_fn()">删除</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>


    <!-- 新增修改 -->
    <el-dialog v-dialogDrag :title="textMap[dialogStatus]" style="margin-top: 200px;" :close-on-click-modal='false'
      :visible.sync="dialogVisible" width="600px" center>
      <el-form :model="temp" :rules="rules" ref="temp" label-width="127px" class="demo-temp">

        <el-form-item label="选择组织" prop="en">
          <el-cascader :show-all-levels="false" v-model="temp.en" :options="options"
            :props="{children:'ChildDatas',value:'Id'}" @change="handleChange" style="width:90%;">
            <template slot-scope="{ node, data }">
              <span>{{ data.Content.Name }}</span>
              <span v-if="!node.isLeaf"> ({{ data.ChildDatas.length }}) </span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item label="选择设备" prop="virtualVariableNo">
          <el-select v-model="temp.virtualVariableNo" multiple collapse-tags filterable placeholder="请选择"
            style="width:90%;">
            <el-option label="全选" value="全选" @click.native="selectAll"></el-option>
            <el-option v-for="(item,i) in optionsed" :key="i" :label="item.Name" :value="item.No">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
//   import { ElectricQualityDayAnalyse, EnergyArea, GetAreaVirtualDeviceVariable, GetVirtualDeviceVariable, SaveAreaVirtualDeviceVariable, GetVirtualDeviceNoAndNames, DeleteMuliIdAreaVirtualDeviceVariable } from "@/utils/request";
  import * as echarts from 'echarts';
  import { parseTime } from "@/utils";
  import $ from 'jquery';
  export default {
    data() {
      return {
        optionsed: [],//选中设备数据 
        options: JSON.parse(localStorage.getItem('treeList')), //选中组织数据
        dialogVisible: false,
        dialogStatus: '',
        textMap: {
          add: "新增",
          edit: "编辑"
        },

        treeList: [],
        error: true,
        num: 19,
        tempId: '',
        flag: true, //显示树形
        filterText: "",
        heights: document.documentElement.clientHeight - 308,
        tableData: [],
        temp: {},
        // defaultProps: {
        //   label: "Name",
        //   children: 'children'
        // },
         defaultProps: {
          label: "Content",
          children: 'ChildDatas'
        },
        deleteData: [],
        rules: {
          virtualVariableNo: [
            { required: true, message: '选择设备', trigger: 'blur' }
          ],
          en: [
            { required: true, message: '选择组织', trigger: 'blur' }
          ],

        },
        columns: [  {
          name: "区域名",
          key: "AreaName",
        } , {
          name: "设备号",
          key: "VirtaulDeviceNo",
          width: 150,
        }, {
          name: "变量名",
          key: "VirtualVariableName",
        }, {
          name: "变量号",
          key: "VirtualVariableNo",
          width: 150,
        },],

      };
    },

    watch: {
      filterText(val) {
        this.$refs.tree.filter(val);
      }
    },
    mounted() {
        this.treeList = JSON.parse(localStorage.getItem('treeList'))
      this.options.map(v => {
        v.label = v.Content.Name
        v.ChildDatas.map(vv => {
          vv.label = vv.Content.Name
          if (vv.ChildDatas && vv.ChildDatas.length) {
          } else {
            delete vv.ChildDatas
          }
        })
      })

      $('.home .el-tree').css({
        maxHeight: this.heights + 150
      })
      this.init();
    },
    methods: {
      //多选删除
      handleSelectionChange(val) { 
        this.deleteData = []
        val.map(v => {
          if (v.Id) { 
            this.deleteData.push(v.Id)
          }
        });
        console.log(this.deleteData,'this.deleteData');
      },
      // 删除
      delete_fn() {
        if (!this.deleteData.length) {
          this.$message({ showClose: true, message: '请勾选', type: 'success' });
          return
        }
        this.$confirm('是否删除此内容', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          DeleteMuliIdAreaVirtualDeviceVariable({ ids: this.deleteData }).then(data => {
            if (data.Success) {
              this.$message({ showClose: true, message: '删除成功', type: 'success' });
              this.deleteData = [];
              this.getList();
            } else {
              data.Msg ? this.$message.error(data.Msg) : this.$message.error('删除失败');
            }
          })
        }).catch(() => {
          // ...
        });

      },
      //选中树形
      virtaul(v) {
        console.log(v);
        this.tempId = v.Id;
        this.getList();
      },
      selectAll() { //单选全选  
        if (this.temp.virtualVariableNo.length < this.optionsed.length) {
          this.temp.virtualVariableNo = [];
          this.optionsed.map((item, i) => {
            this.temp.virtualVariableNo.push(item.No);
          });
          this.temp.virtualVariableNo.unshift("全选");
        } else {
          this.temp.virtualVariableNo = [];
        }
      },
      //选中 组织 数据
      handleChange(value) {
        this.temp.energyAreaId = value[value.length - 1];
        console.log(value[value.length - 1]);
        // GetVirtualDeviceNoAndNames({
        //   "virtualDeviceNos": [this.temp.energyAreaId]
        // }).then(res => {
        //   this.optionsed = res.Response
        // })

      },
      // 确认添加
      add_fn(formName) {
        var d = {
          "value": [
          ]
        };
        this.temp.virtualVariableNo.map(v => {
          var b = {
            "energyAreaId": this.tempId,
            "virtaulDeviceNo": this.temp.energyAreaId,
            "virtualVariableNo": v
          };
          if (v != '全选') {
            d.value.push(b)
          }

        })

        this.$refs[formName].validate(valid => {
          if (valid) {
            SaveAreaVirtualDeviceVariable(d).then(data => {
              if (data && data.Success) {
                this.getList();
                this.dialogVisible = false;
                this.$message({ showClose: true, message: '添加成功', type: 'success' });
              } else {
                if (data && data.Msg) {
                  this.$message.error(data.Msg);
                }
              }

            })
          } else {
            return false;
          }
        });
      },
      // 确认编辑
      edit_fn() {
        this.$refs['temp'].validate(valid => {
          if (valid) {
            EnergyBuildingEdit(this.temp).then(data => {
              if (data.Success) {
                this.getList();
                this.dialogVisible = false;
                this.$message({ showClose: true, message: '修改成功', type: 'success' });
              } else {
                data.Msg ? this.$message.error(data.Msg) : this.$message.error('修改失败');
              }

            })

          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed(v) {
        this.dialogStatus = "edit";
        this.temp = Object.assign({}, v);

        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      // 添加弹窗
      add_ed() {
        this.dialogStatus = 'add';
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        this.temp = {};
      },
      //下载excel表格
      exportList() {
        import('@/vendor/Export2Excel').then(excel => {
          const tHeader = [];
          var filterVal = [];
          for (const key in this.columns) {
            if (Object.hasOwnProperty.call(this.columns, key)) {
              tHeader.push(this.columns[key].name);
              filterVal.push(this.columns[key].key);
            }
          }

          const list = this.tableData;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: '数据',
            autoWidth: true,
            bookType: 'xlsx'
          });
        });
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => {
          return v[j];
        }));
      },


      //获取数据
      getList() {
        this.tableData = [];
        // GetAreaVirtualDeviceVariable({
        //   "value": [this.tempId]
        // }).then(res => {
        //   this.tableData = res.Response;
        //   for (let i = 0; i < 15; i++) {
        //     if (this.tableData.length < 15) {
        //       this.tableData.push({})
        //     }

        //   }
        // })
      },

      // 树形筛选
      filterNode(value, data) {
        if (!value) return true;
        return data.Name.indexOf(value) !== -1;
      },
      //先根据id和parentId的关系生成关系树
      makeTree(arr, Id) {
        var temp = [];
        for (var i = 0; i < arr.length; i++) {
          //如果某个元素的parentId和传入的pid相等，作为pid对应id对象的children集合中的数据 
          if (arr[i].UpId == Id) {
            temp.push(arr[i]);
            //再递归的生成关系树
            arr[i].children = this.makeTree(arr, arr[i].Id);
          }
        }
        return temp;
      },
      // 初始化图表
      init() {
        //树形列表
        // EnergyArea({ "Page": 1, "Rows": 999 }).then(res => {
        //   if (res.Success) {
        //     this.treeList = this.makeTree(res.Response.data, null);
        //     // this.tempId = this.treeList[0].Id;
        //     // this.getList();
        //   }
        // });

        // 选择组织数据

        // treeList:this.$store.state.settings.treeList || JSON.parse(localStorage.getItem('treeList')),

      }

    }
  };
</script>

<style lang="scss" scoped>
  .custom-tree-node{
    position: relative;
    padding: 6px 224px;
    display: block; 
    padding-left: 3px;
  }
  .filter-tree{
    height: 100%;overflow-y: scroll;
  }
  .filter-tree::-webkit-scrollbar {
  display: none;
}
  .item_p {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: #f5f7fa;
    color: #000;
  }

  .home {
    padding: 10px;
    background-color: #eceef2;
    height: calc(100vh - 86px) !important;

    >.el-row {
      background-color: #fff;
      height: calc(100vh - 110px)
    }
  }

  .name-wrapper {
    background: #1890ff;
    color: #fff;
  }

  .radio_box {
    border: 1px solid #d7d7d7;
    border-radius: 5px;
    padding: 5px 3px;

    .el-radio {
      margin-right: 3px;
    }
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .wrapper {
    width: 100%;
    height: 500px;
  }

  .pagination_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
</style>